import { useState } from 'react';
import { faqItems } from '@/mocks/homepage';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900">常见问题</h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">关于爆料专区的常见疑问解答</p>
        </div>

        <div className="space-y-2 md:space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-200/50 transition-colors duration-200"
              >
                <h3 className="text-sm md:text-base font-bold text-foreground-900 pr-4 flex-1">
                  <span className="text-primary-500 mr-2 font-black">Q{idx + 1}</span>
                  {item.q}
                </h3>
                <i
                  className={`flex-shrink-0 text-foreground-500 transition-transform duration-300 text-lg ${
                    openIndex === idx ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-4 md:px-5 pb-4 md:pb-5 pt-0">
                  <p className="text-sm text-foreground-700 leading-relaxed pl-5 md:pl-6">{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}